<template>
  <div class="item">
    <!-- width 100% -->
    <div id="content-section" class="item-content" :class="highlightContent(highlight)">
      <p>{{ content }}</p>
    </div>
    <div
        id="value-left-right-section"
        v-if="!isValueLeftRightEqual(value)"
        class="item-footer border-x">
      <!-- width 50% Left -->
      <p class="item-value-50 item-value-divider-start">
        {{ value.left }}
      </p>
      <!-- width 50% Right -->
      <p class="item-value-50">
        {{ value.right }}
      </p>
    </div>
    <div id="value-full-section" v-else-if="isValueLeftRightNotNull(value)">
      <p class="item-value-100 item-value-border">
        {{ value.left }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "InsuranceTable2Item",
  props: ['data', 'highlight'],
  data: function () {
    return {
      content: 'N/A',
      value: {
        left: '0',
        right: '1',
      }
    }
  },
  methods: {
    isValueLeftRightEqual: function ({ left, right }) {
      return left === right
    },
    isValueLeftRightNotNull: function ({ left, right }) {
      return !(left === 'null' || right === 'null')
    },
    highlightContent: function (highlight) {
      return highlight ? 'highlight' : ''
    }
  },
  created: function () {
    const { content, value: { left, right } } = this.data
    this.content = content
    this.value.left = left
    this.value.right = right
  }
}
</script>

<style scoped>
.highlight {
  background: #E6F6EA;
}

.item {
  display: block;
  background: white;
}

.item-value-50 {
  width: 50%;
  display: inline-block;
  background: #C3E9CC;
  color: black;
  font-weight: bold;
  text-align: center;
}

.item-value-100 {
  display: block;
  background: #C3E9CC;
  color: black;
  font-weight: bold;
  text-align: center;
}

.border-x {
  border-top: 1px solid whitesmoke;
  border-bottom: 1px solid whitesmoke;
}

.item-value-divider-start {
  border-right: 1px solid whitesmoke;
}

.item-footer {
  display: block
}
</style>
